import React, { useEffect, useState } from "react";
import "./orders.scss";
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";
import dividerOne from "../../../../images/Vector 12.png";
import Datedown from "../../../../images/DateDown.svg";
import searchbar from "../../../../images/search-normal.svg";

import divider from "../../../../images/Vector 11.png";
import axios from "axios";
import OrderDateOptions from "./OrderDateOptions"; // Import the OrderDateOptions component
import DatePickerModal from "./CustomDatePicker"; 
import product from "../../../../images/Vector.svg";

import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SellerNavigationComponent from "./SellerNavigationComponent";
const baseUrl = process.env.REACT_APP_BASEURL;
const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [activeLink, setActiveLink] = useState("");

  const [order, setOrder] = useState([]);
  const [customModalIsOpen, setCustomModalIsOpen] = useState(false);
  const state = useSelector((state) => state.sellers);
  const { sellerAuth } = state;
  // console.log(sellerAuth._id, "jj");
  const [details, setDetails] = useState("");
  const statusColors = {
    Pending: 'orange',
    Confirmed: 'blue',
    Delivered: 'green',
    Cancelled: 'red',
    Shipped: 'blue',
    Returned: 'yellow',
  };
  const openCustomModal = () => {
    setCustomModalIsOpen(true);
  };
   const closeCustomModal = () => {
    setCustomModalIsOpen(false);
  };

  const handleToday = () => {
    // Handle Today option
    console.log("Today clicked");
    closeModal();
  };

  const handleYesterday = () => {
    // Handle Yesterday option
    console.log("Yesterday clicked");
    closeModal();
  };

  const handleCustom = () => {
    // Handle Custom option
    console.log("Custom clicked");
    closeModal();
    openCustomModal();
  };
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
  
    const openModal = () => {
      setModalIsOpen(true);
    };
  
    const closeModal = () => {
      setModalIsOpen(false);
    };
  
    const handleDateSelect = (date) => {
      // Handle the selected date as needed
      console.log("Selected Date:", date);
      // You can update your state or perform other actions here
    };
    const [selectedOrders, setSelectedOrders] = useState([]);
    const handleCheckboxChange = (orderId) => {
      const selectedOrderIndex = selectedOrders.indexOf(orderId);
      let newSelectedOrders = [...selectedOrders];
  
      if (selectedOrderIndex === -1) {
        newSelectedOrders.push(orderId);
      } else {
        newSelectedOrders.splice(selectedOrderIndex, 1);
      }
  
      setSelectedOrders(newSelectedOrders);
    };
  
    const handleSelectAll = () => {
      const allOrderIds = orders.map((item) => item?._id);
      setSelectedOrders(allOrderIds);
    };
 
  useEffect(() => {
    const fetchDetails = async () => {
      const response = await axios.post(
        `${baseUrl}/api/reseller/singleuserdetail`,
        {
          reseller: sellerAuth?._id,
        }
      );
      setDetails(response.data);
      console.log(response.data,'jjjj');
    };
    fetchDetails();
  }, []);
  const [details1, setDetails1] = useState("");

useEffect(() => {
  const seller=  localStorage.getItem("sellerregisterInfo");
  const sellerInfoObject = JSON.parse(seller);
  console.log(sellerInfoObject?._id,'selleridd'); 
  setDetails1(sellerInfoObject?._id); 
 
  }, []);
  console.log(details1,'detailsss');
  const fetchaddress = async () => {
    const seller=  localStorage.getItem("sellerregisterInfo");
    const sellerInfoObject = JSON.parse(seller);
    console.log(sellerInfoObject?._id); // Check the entire object
  
    try {
      const response = await axios.post(`${baseUrl}/api/order/orderstatus/`, {
        reseller: sellerInfoObject?._id,
        order_status: status,
        startDate: startDate,
        endDate: endDate,
      });
      setOrders(response.data);
      console.log(response.data, "qq");
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchaddress();
  }, []);
  console.log(sellerAuth?._id, "ddd");
  const handleStatusChange = async (value, id,productid) => {
    console.log(id, "mmm", value);

    try {
      let response;

      if (value === "Pending") {
        response = await axios.post(`${baseUrl}/api/order/changestatus/${id}/${productid}`, {
          order_status: value,
        });
      } else if (value === "Confirmed") {
        response = await axios.post(`${baseUrl}/api/order/changestatus/${id}/${productid}`, {
          order_status: value,
        });
      // } else if (value === "Delivered") {
      //   response = await axios.post(`${baseUrl}/api/order/changestatus/${id}/${productid}`, {
      //     order_status: value,
      //   });
      } else if (value === "Cancelled") {
        response = await axios.post(`${baseUrl}/api/order/changestatus/${id}/${productid}`, {
          order_status: value,
        });
      // } else if (value === "Shipped") {
      //   response = await axios.post(`${baseUrl}/api/order/changestatus/${id}/${productid}`, {
      //     order_status: value,
      //   });
      // } else if (value === "Returned") {
      //   response = await axios.post(`${baseUrl}/api/order/changestatus/${id}/${productid}`, {
      //     order_status: value,
      //   });
      }
      

      if (response) {
        setOrder(response.data, "hhh");
        fetchaddress();
        toast.success("Status Updated");
      } else {
        toast.error("Error");
      }
    } catch (error) {
      console.error(error);
      toast.error("Error");
    }
  };

const [status,setStatus]=useState("Pending")
  console.log(orders, "orders");
const handleClick=(id)=>{
console.log(id,'hh');
setStatus(id);
setActiveLink("Pending");
}
const CancellhandleClick=(id)=>{
  setActiveLink("Cancelled");
  setStatus(id);

}
const ShiphandleClick=(id)=>{
  setStatus(id);
  setActiveLink("Shipped");

}
  const ConfirmhandleClick  =(id)=>{ 
    setStatus(id);
    setActiveLink("Confirmed");

  }




const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(new Date());
const handleDateChange = (e) => {
  // setselecteddate(e.target.value); // Update selecteddate state
  if (e.target.value !== "Custom Date") {
    setStartDate(null);
    setEndDate(null);
  }
};
console.log(sellerAuth?._id,'aa');
const [PendingordersInCurrentYear, setPendingordersInCurrentYear] = useState([]);
const [confirmedordersInCurrentYear, setconfirmedordersInCurrentYear] = useState([]);
const [shippedordersInCurrentYear, setshippedordersInCurrentYear] = useState([]);
const [cancelledordersInCurrentYear, setcancelledordersInCurrentYear] = useState([]);

const fetchDetails = async () => {
  const seller=  localStorage.getItem("sellerregisterInfo");
    const sellerInfoObject = JSON.parse(seller);
    console.log(sellerInfoObject?._id);
  const response = await axios.post(`${baseUrl}/api/order/orderstatus/`, {
    reseller: sellerInfoObject?._id,
    order_status: status,
    startDate: startDate,
    endDate: endDate,
  });

  if (status === "Pending") {
    setPendingordersInCurrentYear(response.data.ordersInCurrentYear);
    console.log( response.data.ordersInCurrentYear,"pending");
  } else if (status === "Confirmed") {
    setconfirmedordersInCurrentYear(response.data.ordersInCurrentYear);
    console.log( response.data.ordersInCurrentYear,"confirmed");

  } else if (status === "Shipped") {
    setshippedordersInCurrentYear(response.data.ordersInCurrentYear);
    console.log( response.data.ordersInCurrentYear,"shipped");

  } else if (status === "Cancelled") {
    setcancelledordersInCurrentYear(response.data.ordersInCurrentYear);
    console.log( response.data.ordersInCurrentYear,"cancelled");

    console.log(response.data, "response.data");
  }
};
useEffect(() => {
  fetchDetails();
}, [status]);


  return (
    <div>
      <ToastContainer />

      <div style={{ display: 'flex' }}>
        <SellerNavigationComponent />

        <img src={divider} className="dividerfour" />
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div>
            <div className="Order-heading">Orders</div>
            <img src={dividerOne} className="dividerTwo" />
            <div
              className="orderinoverview"
              style={{ display: 'flex', height: '30px' }}
            >
              <div className="pending-order"
              onClick={()=>{handleClick("Pending")}}
              style={{ color: activeLink === "Pending" ? "#0099FF" : "" }}

              >Pending</div>




              <div className="ready-order"     
                        onClick={()=>{ConfirmhandleClick("Confirmed")}}
                        style={{ color: activeLink === "Confirmed" ? "#0099FF" : "" }}

>Ready to Ship
              </div>
              <div className="shipped-order" onClick={()=>{ShiphandleClick("Shipped")}}
                            style={{ color: activeLink === "Shipped" ? "#0099FF" : "" }}
              >Shipped</div>
              <div className="cancelled-order" onClick={()=>{CancellhandleClick("Cancelled")}}
                            style={{ color: activeLink === "Cancelled" ? "#0099FF" : "" }}
                            >Cancelled</div>
            </div>
            </div>

            <img src={dividerOne} className="dividerthree" />
            <div
              className="filterbydiv"
              style={{
                display: 'flex',
                alignItems: 'center',
              justifyContent:"space-between",
              // gap:"30px"
                // height: '30px',
                width: "98%"
              }}
            >
              <div className="searchingorderdiv" style={{display:"flex"}}>
              <div className="Filter" >
                Filter by:
              </div>
              <button
                className="Datebutton"
                onClick={openModal}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                Order Date
                <img
                  src={Datedown}
                  alt="dropdown"
                  className="dropdown"
                  style={{ marginLeft: '5px' }}
                />
              </button>
              <OrderDateOptions
                isOpen={modalIsOpen}
                closeModal={closeModal}
                handleToday={handleToday}
                handleYesterday={handleYesterday}
                handleCustom={handleCustom}
              />
              <DatePickerModal
                isOpen={customModalIsOpen}
                closeModal={closeCustomModal}
                handleDateSelect={handleDateSelect}
              />
            </div>
          
                
                <div>
                <input
                  placeholder="Search SKU, Mobile number, Order ID "
                  className="searchingordermaindiv"
                  style={{
                    backgroundImage: `url(${searchbar})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: '10px center',
                    paddingLeft: '40px',
                
                  }}
                />
              </div>
              </div>
          <div>
            <img src={dividerOne} className="dividerthree" />

            <table className="bordered-tableOrder">
              <thead>
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      className="largerCheckbox"
                      onChange={handleSelectAll}
                    />
                  </th>
                  <th>Product Details</th>
                  <th>Order ID</th>
                  <th>SKU ID</th>
                  <th>Qty</th>
                  <th>Variation/Size</th>
                  <th>Order Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              {status==="Pending"?<>
              <tbody>
                {PendingordersInCurrentYear?.map((item, index) => (
                  <tr key={item?._id}>
                    
                    <td>
                      <input
                        type="checkbox"
                        className="largerCheckbox"
                        checked={selectedOrders.includes(item?._id)}
                        onChange={() => handleCheckboxChange(item?._id)}
                      />
                    </td>
                    <td>
                      {item.orderQuantities.map((orderItem, innerIndex) => (
                        <div style={{display:"flex",gap:"10px"}}
                          key={orderItem.product._id}
                          className="orderandreturndiv"
                        >
                          {orderItem?.product?.image &&
                          orderItem.product.image[0] ? (
                            <img
                              alt=""
                              src={orderItem.product.image[0]}
                              className="ecomproductdetailsimage"
                            />
                          ) : orderItem?.product?.properties &&
                            orderItem.product.properties[0]?.image ? (
                            <img
                              alt=""
                              src={
                                orderItem.product.properties[0].image[0]
                              }
                              className="ecomproductdetailsimage"
                            />
                          ) : (
                            <div>No image available</div>
                          )}

                          <p className="orderandreturnsproductname">
                            {orderItem.product.EcomproductName}
                          </p>
                        </div>
                      ))}
                    </td>

                    <td>
                    {item?.orderQuantities?.map((items, innerIndex) => (
                      <p className=" orderandreturnsproductorderid">{items?._id}</p>
                      ))}
                      </td>
                    <td>  {item?.orderQuantities?.map((items, innerIndex) => (
                      <p className=" orderandreturnsproductorderid">{items?.product?.sku}</p>
                      ))}</td>

                    <td>
                    {item?.orderQuantities?.map((items, innerIndex) => (
                      <p className=" orderandreturnsproductorderid">{items?.quantity}</p>
                      ))}
                      </td>
                    <td></td>
                    <td>
                      {new Date(item?.ordered_on).toLocaleDateString()}
                    </td>
                    <td>
                      {item?.orderQuantities?.map((items, innerIndex) => (
                        <div
                          key={innerIndex}
                          className="action-buttons-container"
                        >
                          <button
                            className="confirmActionbutton"
                            onClick={() =>
                              handleStatusChange(
                                'Confirmed',
                                item?._id,
                                items?.product?._id
                              )
                            }
                          >
                            Accept
                          </button>
                            <button
                              className="CancelledActionbutton"
                              onClick={() =>
                                handleStatusChange(
                                  'Cancelled',
                                  item?._id,
                                  items?.product?._id
                                )
                              }
                            >
                              Cancel
                            </button>
                        </div>
                      ))}
                    </td>
                  </tr>
                ))}
              </tbody>

              </>:status==="Confirmed"?<> <tbody>
                {confirmedordersInCurrentYear?.map((item, index) => (
                  <tr key={item?._id}>
                    
                    <td>
                      <input
                        type="checkbox"
                        className="largerCheckbox"
                        checked={selectedOrders.includes(item?._id)}
                        onChange={() => handleCheckboxChange(item?._id)}
                      />
                    </td>
                    <td>
                      {item.orderQuantities.map((orderItem, innerIndex) => (
                        <div style={{display:"flex",gap:"10px"}}
                          key={orderItem.product._id}
                          className="orderandreturndiv"
                        >
                          {orderItem?.product?.image &&
                          orderItem.product.image[0] ? (
                            <img
                              alt=""
                              src={orderItem.product.image[0]}
                              className="ecomproductdetailsimage"
                            />
                          ) : orderItem?.product?.properties &&
                            orderItem.product.properties[0]?.image ? (
                            <img
                              alt=""
                              src={
                                orderItem.product.properties[0].image[0]
                              }
                              className="ecomproductdetailsimage"
                            />
                          ) : (
                            <div>No image available</div>
                          )}

                          <p className="orderandreturnsproductname">
                            {orderItem.product.EcomproductName}
                          </p>
                        </div>
                      ))}
                    </td>

                    <td>
                    {item?.orderQuantities?.map((items, innerIndex) => (
                      <p className=" orderandreturnsproductorderid">{items?._id}</p>
                      ))}
                      </td>
                    <td>  {item?.orderQuantities?.map((items, innerIndex) => (
                      <p className=" orderandreturnsproductorderid">{items?.product?.sku}</p>
                      ))}</td>

                    <td>
                    {item?.orderQuantities?.map((items, innerIndex) => (
                      <p className=" orderandreturnsproductorderid">{items?.quantity}</p>
                      ))}
                      </td>
                    <td></td>
                    <td>
                      {new Date(item?.ordered_on).toLocaleDateString()}
                    </td>
                    {/* <td>
                      {item?.orderQuantities?.map((items, innerIndex) => (
                        <div
                          key={innerIndex}
                          className="action-buttons-container"
                        >
                          <button
                            className="confirmActionbutton"
                            onClick={() =>
                              handleStatusChange(
                                'Confirmed',
                                item?._id,
                                items?.product?._id
                              )
                            }
                          >
                            Accept
                          </button>
                            <button
                              className="CancelledActionbutton"
                              onClick={() =>
                                handleStatusChange(
                                  'Cancelled',
                                  item?._id,
                                  items?.product?._id
                                )
                              }
                            >
                              Cancel
                            </button>
                        </div>
                      ))}
                    </td> */}
                  </tr>
                ))}
              </tbody></>:status==="Shipped"?<> <tbody>
                {shippedordersInCurrentYear?.map((item, index) => (
                  <tr key={item?._id}>
                    
                    <td>
                      <input
                        type="checkbox"
                        className="largerCheckbox"
                        checked={selectedOrders.includes(item?._id)}
                        onChange={() => handleCheckboxChange(item?._id)}
                      />
                    </td>
                    <td>
                      {item.orderQuantities.map((orderItem, innerIndex) => (
                        <div style={{display:"flex",gap:"10px"}}
                          key={orderItem.product._id}
                          className="orderandreturndiv"
                        >
                          {orderItem?.product?.image &&
                          orderItem.product.image[0] ? (
                            <img
                              alt=""
                              src={orderItem.product.image[0]}
                              className="ecomproductdetailsimage"
                            />
                          ) : orderItem?.product?.properties &&
                            orderItem.product.properties[0]?.image ? (
                            <img
                              alt=""
                              src={
                                orderItem.product.properties[0].image[0]
                              }
                              className="ecomproductdetailsimage"
                            />
                          ) : (
                            <div>No image available</div>
                          )}

                          <p className="orderandreturnsproductname">
                            {orderItem.product.EcomproductName}
                          </p>
                        </div>
                      ))}
                    </td>

                    <td>
                    {item?.orderQuantities?.map((items, innerIndex) => (
                      <p className=" orderandreturnsproductorderid">{items?._id}</p>
                      ))}
                      </td>
                    <td>  {item?.orderQuantities?.map((items, innerIndex) => (
                      <p className=" orderandreturnsproductorderid">{items?.product?.sku}</p>
                      ))}</td>

                    <td>
                    {item?.orderQuantities?.map((items, innerIndex) => (
                      <p className=" orderandreturnsproductorderid">{items?.quantity}</p>
                      ))}
                      </td>
                    <td></td>
                    <td>
                      {new Date(item?.ordered_on).toLocaleDateString()}
                    </td>
                    {/* <td>
                      {item?.orderQuantities?.map((items, innerIndex) => (
                        <div
                          key={innerIndex}
                          className="action-buttons-container"
                        >
                          <button
                            className="confirmActionbutton"
                            onClick={() =>
                              handleStatusChange(
                                'Confirmed',
                                item?._id,
                                items?.product?._id
                              )
                            }
                          >
                            Accept
                          </button>
                            <button
                              className="CancelledActionbutton"
                              onClick={() =>
                                handleStatusChange(
                                  'Cancelled',
                                  item?._id,
                                  items?.product?._id
                                )
                              }
                            >
                              Cancel
                            </button>
                        </div>
                      ))}
                    </td> */}
                  </tr>
                ))}
              </tbody></>:status==="Cancelled"?<> <tbody>
                
                {cancelledordersInCurrentYear?.map((item, index) => (
                  <tr key={item?._id}>
                    
                    <td>
                      <input
                        type="checkbox"
                        className="largerCheckbox"
                        checked={selectedOrders.includes(item?._id)}
                        onChange={() => handleCheckboxChange(item?._id)}
                      />
                    </td>
                    <td>
                      {item.orderQuantities.map((orderItem, innerIndex) => (
                        <div style={{display:"flex",gap:"10px"}}
                          key={orderItem.product._id}
                          className="orderandreturndiv"
                        >
                          {orderItem?.product?.image &&
                          orderItem.product.image[0] ? (
                            <img
                              alt=""
                              src={orderItem.product.image[0]}
                              className="ecomproductdetailsimage"
                            />
                          ) : orderItem?.product?.properties &&
                            orderItem.product.properties[0]?.image ? (
                            <img
                              alt=""
                              src={
                                orderItem.product.properties[0].image[0]
                              }
                              className="ecomproductdetailsimage"
                            />
                          ) : (
                            <div>No image available</div>
                          )}

                          <p className="orderandreturnsproductname">
                            {orderItem.product.EcomproductName}
                          </p>
                        </div>
                      ))}
                    </td>

                    <td>
                    {item?.orderQuantities?.map((items, innerIndex) => (
                      <p className=" orderandreturnsproductorderid">{items?._id}</p>
                      ))}
                      </td>
                    <td>  {item?.orderQuantities?.map((items, innerIndex) => (
                      <p className=" orderandreturnsproductorderid">{items?.product?.sku}</p>
                      ))}</td>

                    <td>
                    {item?.orderQuantities?.map((items, innerIndex) => (
                      <p className=" orderandreturnsproductorderid">{items?.quantity}</p>
                      ))}
                      </td>
                    <td></td>
                    <td>
                      {new Date(item?.ordered_on).toLocaleDateString()}
                    </td>
                    {/* <td>
                      {item?.orderQuantities?.map((items, innerIndex) => (
                        <div
                          key={innerIndex}
                          className="action-buttons-container"
                        >
                          <button
                            className="confirmActionbutton"
                            onClick={() =>
                              handleStatusChange(
                                'Confirmed',
                                item?._id,
                                items?.product?._id
                              )
                            }
                          >
                            Accept
                          </button>
                            <button
                              className="CancelledActionbutton"
                              onClick={() =>
                                handleStatusChange(
                                  'Cancelled',
                                  item?._id,
                                  items?.product?._id
                                )
                              }
                            >
                              Cancel
                            </button>
                        </div>
                      ))}
                    </td> */}
                  </tr>
                ))}
              </tbody></>:<></>}
             
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Orders;